// extracted by mini-css-extract-plugin
export var chevron = "SelectDropdown-module__chevron___Sr4oZ";
export var chevronOpen = "SelectDropdown-module__chevronOpen___UcGy3";
export var menu = "SelectDropdown-module__menu___HirVK";
export var menuList = "SelectDropdown-module__menuList___z4dcl";
export var option = "SelectDropdown-module__option___4OiRU";
export var optionSelected = "SelectDropdown-module__optionSelected___98tBN";
export var trigger = "SelectDropdown-module__trigger___La6d1";
export var wrapper = "SelectDropdown-module__wrapper___8SfIf";